import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ApplicationInsights, Snippet } from '@microsoft/applicationinsights-web';
import {
  APP_INSIGHTS_FACTORY,
  ApplicationInsightsService,
  TELEMETRY_CONFIG,
  TelemetryConfig
} from './application-insights.service';

export function provideTelemetry(config: TelemetryConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    ApplicationInsightsService,
    {
      provide: APP_INSIGHTS_FACTORY,
      useFactory: () => (snippet: Snippet) => new ApplicationInsights(snippet)
    },
    {
      provide: TELEMETRY_CONFIG,
      useValue: config
    }
  ]);
}
